<template>
	<div class="subject-audit-list">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right">
										<Breadcrumb />
									</div>
									<h3 class="header-title mb-3">
										学校审核
										<span class="ml-2"
											v-if="userinfo.roleId && userinfo.roleId.includes('2')">（本轮初审截止：{{projectData.trialEndTime}}）</span>
									</h3>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>

						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<template v-if="!isShowDetail">
											<el-row :gutter="20">
												<el-col :span="12">
													<!-- <el-select v-model="queryForm.projectId" placeholder="请选择" @change="changeProject">
														<el-option v-for="item in projectOptions" :key="item.id" :label="item.projectName" :value="item.id"></el-option>
													</el-select> -->
													<el-input style="width: 200px;margin: 0 10px;" placeholder="请输入内容"
														v-model="queryForm.keywords" clearable></el-input>
													<el-button type="success" @click="search">查询</el-button>
												</el-col>
												<el-col :span="12" style="text-align: right;">
													<!-- <el-button type="primary" icon="el-icon-edit-outline">课题申报</el-button> -->
													<!-- <el-button type="primary" icon="el-icon-search" @click="goProjectApproval">立项查询</el-button> -->
													<el-button type="primary" icon="el-icon-share" @click="exportExcel">
														导出Excel</el-button>
												</el-col>
											</el-row>

											<el-table :header-cell-style="tableStyle" :data="topicList" border
												style="width: 100%;margin-top: 20px;">
												<el-table-column label="序号" width="50">
													<template #default='scope'>
														{{(scope.$index+1)+((queryForm.pageNumber-1)*queryForm.pageSize)}}
													</template>
												</el-table-column>
												<el-table-column prop="name" label="课题名称" width="180">
													<template v-slot="scope">
														<div style="color: deepskyblue;cursor: pointer;"
															@click="viewTopicDetail(scope.row)">{{scope.row.name}}</div>
													</template>
												</el-table-column>
												<el-table-column prop="oneEmceeName" label="负责人" width="65">
												</el-table-column>
												<el-table-column prop="createTime" label="申报时间">
													<template slot-scope="scope">
														{{scope.row.createTime | getTime}}
													</template>
												</el-table-column>
												<el-table-column prop="unitName" label="工作单位"></el-table-column>
												<el-table-column prop="learningTypeName" label="所属学段" width="80">
												</el-table-column>
												<el-table-column prop="disciplineName" label="学科" width="60">
												</el-table-column>
												<!-- <el-table-column prop="projectTypeName" label="课题类别" width="80"></el-table-column> -->
												<el-table-column prop="type" label="审核进度" width="320">
													<template slot-scope="scope">
														<ReviewProgress :status="scope.row.type"></ReviewProgress>
													</template>
												</el-table-column>
												<el-table-column label="操作">
													<template slot-scope="scope">
														<el-button v-if="scope.row.type == 1" type="text"
															@click="goReview(scope.row.id)">审核</el-button>
														<el-popconfirm
															v-if="[2,3,4].includes(scope.row.type) && Date.now() < new Date(projectData.trialEndTime).getTime()"
															title="确定要撤回吗？" @confirm="recallReview(scope.row.id)">
															<el-button slot="reference" type="text">撤回</el-button>
														</el-popconfirm>
													</template>
												</el-table-column>
											</el-table>

											<!-- 用于导出表格 -->
											<el-table v-show="false" id="exportTab" :header-cell-style="tableStyle"
												:data="topicList" border style="width: 100%;margin-top: 20px;">
												<el-table-column label="序号" type="index" width="50"></el-table-column>
												<el-table-column prop="name" label="课题名称" width="180"></el-table-column>
												<el-table-column prop="oneEmceeName" label="负责人" width="65">
												</el-table-column>
												<el-table-column prop="createTime" label="申报时间">
													<template slot-scope="scope">
														{{scope.row.createTime | getTime}}
													</template>
												</el-table-column>
												<el-table-column prop="unitName" label="工作单位"></el-table-column>
												<el-table-column prop="learningTypeName" label="所属学段" width="80">
												</el-table-column>
												<el-table-column prop="disciplineName" label="学科" width="60">
												</el-table-column>
												<!-- <el-table-column prop="projectTypeName" label="课题类别" width="80"></el-table-column> -->
												<el-table-column prop="type" label="审核进度" width="320">
													<template slot-scope="scope">
														{{scope.row.type | getReviewProgress}}
													</template>
												</el-table-column>
											</el-table>
											<!-- 分页器 -->
											<div style="text-align: center;margin-top: 20px;">
												<el-pagination @size-change="handleSizeChange"
													@current-change="handleCurrentChange"
													:current-page="queryForm.pageNumber" :page-sizes="[10, 20, 50]"
													:page-size="queryForm.pageSize"
													layout="total, sizes, prev, pager, next, jumper" :total="total">
												</el-pagination>
											</div>
										</template>

										<TopicReviewDetail @goback="isShowDetail=false" :topicInfo="topicInfo" v-else />

									</div>
									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
	import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue'
	import ReviewProgress from '@/views/backstage/components/ReviewProgress.vue';
	import {
		getTopicsDeclarationList,
		getEduProjectLsit,
		recallCell
	} from '@/api/after/projectApplication.js';
	import {
		TopicDeclarationDetail, getSchoolAuditExcel
	} from '@/api/after/schoolAudit.js';
	import TopicReviewDetail from '../components/TopicReviewDetail.vue'
	import FileSaver from "file-saver";
	import XLSX from "xlsx";
	export default {
		components: {
			Breadcrumb,
			ReviewProgress,
			TopicReviewDetail
		},
		data() {
			return {
				tableStyle: {
					backgroundColor: '#7e9be2',
					color: '#fff',
					textAlign: 'center',
				},
				queryForm: {
					keywords: '',
					pageNumber: 1,
					pageSize: 10,
					projectId: 0,
					type: 0,
				},
				total: 0,
				projectOptions: [],
				topicList: [], //课题列表
				userinfo: JSON.parse(sessionStorage.getItem('userInfo') || '{}'),
				projectData: JSON.parse(sessionStorage.getItem('projectData') || '{}'),
				isShowDetail: false,
				topicInfo: null, //课题详情
			};
		},
		async created() {
			await this.getData()
			if (this.projectData.id) {
				this.queryForm.projectId = +this.projectData.id;
				await this.getTopicsDeclarationList();
			}
			console.log(this.projectData.trialEndTime, '初审时间');
		},
		methods: {
			//撤回消息
			async recallReview(id) {
				let params = {
					declareId: id,
					projectId: this.projectData.id,
					type: 0
				}
				const res = await recallCell(params)
				if (res.code == 200) {
					this.$message.success('撤回成功')
					this.getTopicsDeclarationList()
				} else {
					this.$message.error(res.data)
				}
			},

			// 课题申报详情
			async TopicDeclarationDetail(id) {
				const res = await TopicDeclarationDetail(id)
				if (res.code == 200) {
					console.log('详情', res);
					this.topicInfo = res.data
					// this.$nextTick(()=>{
					// 	// 数据请求成功之后渲染pdf
					// 	if (Object.keys(this.topicInfo).length) {
					// 		this.$refs.myIframe.contentWindow.location.replace(`${this.uploadUrl}/upload/downloadPdf/${this.topicInfo.declarationContents}`)
					// 	}
					// })
				} else {
					this.$message.error(res.data)
				}
			},
			// 点击课题名称查看详情
			async viewTopicDetail(data) {
				await this.TopicDeclarationDetail(data.id)
				this.isShowDetail = true
			},
			// 跳转到立项列表
			goProjectApproval() {
				this.$router.push('/backstage/approvedProject')
			},
			// 导出Excel列表
			async exportExcel() {
				const res = await getSchoolAuditExcel(this.queryForm.projectId, 0)
				const aLink = document.createElement("a");
				let blob = new Blob([res], { type: "application/vnd.ms-excel" })
				aLink.href = URL.createObjectURL(blob)
				aLink.setAttribute('download', '学校审核表' + '.xlsx') // 设置下载文件名称
				aLink.click()
				return
				var xlsxParam = {
					raw: true
				};
				var wb = XLSX.utils.table_to_book(
					document.querySelector("#exportTab"),
					xlsxParam
				);
				var wbout = XLSX.write(wb, {
					bookType: "xlsx",
					bookSST: true,
					type: "array",
				});
				try {
					FileSaver.saveAs(
						new Blob([wbout], {
							type: "application/octet-stream"
						}),
						"学校审核表.xlsx"
					);
				} catch (e) {
					if (typeof console !== "undefined") {
						console.log(e, wbout);
					}
				}
				return wbout;
			},
			// 获取课题申报列表
			async getTopicsDeclarationList() {
				const res = await getTopicsDeclarationList(this.queryForm);
				if (res.code == 200) {
					console.log('课题申报列表', res);
					this.topicList = res.data.records;
					this.total = res.data.total;
				} else {
					this.$message.error(res.data);
				}
			},
			// 获取所有课题
			getData() {
				getEduProjectLsit().then(res => {
					console.log('所有课题', res);
					if (res.code == 200) {
						this.projectOptions = res.data;
					} else {
						this.$message.error(res.data);
					}
				});
			},
			// 去审核
			goReview(id) {
				this.$router.push(`/backstage/schoolTopicReviewDetail?topicId=${id}&auditType=0`) //auditType:0是校审核1是区审核
			},
			// 搜索
			search() {
				this.queryForm.pageNumber = 1
				this.getTopicsDeclarationList()
			},
			// 改变当前项目
			changeProject(e) {
				console.log(e);
				this.queryForm.projectId = e
				this.getTopicsDeclarationList()
			},
			handleSizeChange(val) {
				this.queryForm.pageSize = val;
				this.getTopicsDeclarationList();
			},

			handleCurrentChange(val) {
				this.queryForm.pageNumber = val;
				this.getTopicsDeclarationList();
			}
		}
	};
</script>

<style scoped lang="scss">
	.card-body {
		padding: 1.5rem 10px;
	}
</style>